module.exports = __webpack_public_path__ + "media/images/bonusForSharing__bg-d2cfed90d0b4b082ccfb702fcf3ee612.jpg";